import util from './_util';

const {
    request
} = util;

export default {
    /**
     * 合同基本信息
     * */
    // 查询所有
    htjbxxType() {
        return request.get('/Contract/save_contract')
    },
    // 添加
    htjbxxAdd(data) {
        return request.post('/Contract/save_contract', data)
    },
    // 删除
    htjbxxDel(params) {
        return request.get('/Contract/delete_contract?ids=' + params)
    },
    // 根据ID查询详情
    htjbxxGetById(params) {
        return request.get('/Contract/get_info?id=' + params)
    },
    // 修改
    htjbxxUpdate(params) {
        return request.post('/Contract/save_contract', params)
    },

    /**
     * 合同付款信息
     * */
    // 添加
    htskxxAdd(data) {
        return request.post('/Contract/save_contract_collect', data)
    },

    // 删除
    htskxxDel(params) {
        return request.get('/Contract/delete_contract_collect?ids=' + params)
    },

    // 修改
    htskxxUpdate(params) {
        return request.post('/Contract/save_contract_collect', params)
    },

    // 获取所有
    htfkxxGetAll() {
        return request.get('/Contract/get_collect_list')
    },


    /**
     * 合同发票信息
     */
    // 添加
    htfpxxAdd(data) {
        return request.post('/Contract/save_contract_invoice', data)
    },

    // 修改
    htfpxxUpdate(params) {
        return request.post('/Contract/save_contract_invoice', params)
    },

    // 删除
    htfpxxDelete(params) {
        return request.get('/Contract/delete_contract_invoice?ids=' + params)
    },
}